<template>
  <v-dialog
    v-model="show"
    @click:outside="close"
    width="500"
    @keydown.esc="close"
  >
    <v-card :loading="status == 'loading'">
      <v-toolbar color="red" dark flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-10 text-center">
        <slot :close="close"></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { mapState } from "vuex";

export default {
  props: ["title", "description", "show", "hide", "submit_data"],
  created() {},
  computed: {
    ...mapState({
      status: state => state.Users.status
    })
  },
  data() {
    return {
      complete_message: "",
      user: {
        email: ""
      }
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    close() {
      this.hide();
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
    async sendData() {
      const is_valid = await this.$refs.validator_delete.validate();
      if (is_valid) {
        this.submit_data();
      }
    }
  }
};
</script>
